import { logger } from '@dealstack/frontend/shared/mechanism/logger/logger';
import { ENVIRONMENT_CATEGORY, EXACT_ENVIRONMENT } from '@dealstack/shared/lib/common/environment';
import { intersection } from 'lodash';

export type ENVIRONMENT_IDENTIFIER = [ENVIRONMENT_CATEGORY, EXACT_ENVIRONMENT | string];

export const getWebEnvironment = (() => {
	const urlEnv: ENVIRONMENT_IDENTIFIER = (() => {
		const hostLocation = window.location.hostname;
		const isLocal = intersection([hostLocation], ['localhost', '127.0.0.1'])?.length > 0;
		if (isLocal) {
			return [ENVIRONMENT_CATEGORY.LOCAL, EXACT_ENVIRONMENT.LOCAL];
		}
		const splitByDot = hostLocation.split('.');
		const isProd = splitByDot.length === 3;
		if (isProd) {
			return [ENVIRONMENT_CATEGORY.PRODUCTION, EXACT_ENVIRONMENT.PRODUCTION];
		}
		return [ENVIRONMENT_CATEGORY.STAGING, splitByDot[1]];
	})();
	const [group, exact] = urlEnv;
	logger.info(`[ENV] Current environment: group(${group}) exact(${exact})`);

	return () => urlEnv;
})();

export const webIsProduction = getWebEnvironment()?.[0] === ENVIRONMENT_CATEGORY.PRODUCTION;
